import { bindActionCreators } from 'redux';

import makeConnect from '@utils/makeConnect';

// TODO: abstract resources action imports by use of a redux registry

// TODO: abstract resources action imports by use of a redux registry
import userModules from '@modules/user/user.module'
import jobModule from '@modules/job/job.module'
import timesheetModule from '@modules/timesheet/timesheet.module'
import accountModule from '@modules/account/account.module'

const resourceActions = {
	account: accountModule.actions,
	admin: userModules.admin.actions,
	client: userModules.client.actions,
	candidate: userModules.candidate.actions,
	job: jobModule.actions,
	timesheet: timesheetModule.actions,
}

export default function UseSingular(resource) {

	if(!resourceActions[resource]) {
		throw new Error(`invalid resource "${resource}"`);
	}

	const mapStateToProps = (state, ownProps) => {
		var {
			data, 
			isEditing,
			error,
		} = state[resource].singular;

		const isNew = ownProps.match.params.id === 'new' || ownProps.match.params.id === undefined;
		
		return {
			data,
			isEditing,
			isNew,
			error,
		}
	}

	const mapDispatchToProps = dispatch => ({
		actions: bindActionCreators(resourceActions[resource], dispatch)
	})

	return makeConnect(mapStateToProps, mapDispatchToProps)

}



// WEBPACK FOOTER //
// ./src/connects/singular.js